import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { LOGIN_ROUTE } from "../../config/RoutesConstants";
import { Field, reduxForm } from "redux-form";
import { TextField, Select } from "redux-form-material-ui";
import {
  required,
  typeInteger,
  typeIntegerOrDecimalOr0,
  typeIntegerOrDecimalMin10,
} from "../../common/Validations";
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import {
  Container,
  Box,
  Button,
  IconButton,
  InputLabel,
  Grid,
  Chip,
  Avatar,
  Paper,
  Typography,
  Tooltip,
  InputAdornment,
  Toolbar,
  MenuItem,
  Select as SelectMUI,
} from "@material-ui/core";
import { actionGetTags } from "../../actions/TagActions";
import ColorField from "../../components/ColorField/ColorField";
import IconPicker from "../../components/IconPicker/IconPicker";
import { withTheme } from "@material-ui/core/styles";
import BackIcon from "@material-ui/icons/ArrowBackRounded";
import Util, { ERROR, SUCCESS, handleSubmitFail } from "../../common/Util";
import _ from "lodash";
import {
  actionSaveTicketType,
  actionGetCategories,
  actionGetTicketTypes,
} from "../../actions/EventActions";
import Settings from "../../provider/base/Settings";
let _handleSubmitFail;
const filterTag = createFilterOptions();
class AddEditTicketType extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onChangeTktPriceProducer = this.onChangeTktPriceProducer.bind(this);
    this.onSelectIcon = this.onSelectIcon.bind(this);
    this.onClean = this.onClean.bind(this);
    this.onSelectTag = this.onSelectTag.bind(this);
    this.onSave = this.onSave.bind(this);
    _handleSubmitFail = this.handleSubmitFail.bind(this);
    this.state = {
      tags: [],
      tagsSelected: [],
      isCombo: false,
      dynamicComboList: [{}],
      selectedComboList: [],
    };
  }

  componentWillReceiveProps(nextProps) {
    const { ticketFormValues: lastTicketFormValues = {} } = this.props;
    const { tktTags: lastTktTags = [] } = lastTicketFormValues;
    const { ticketFormValue: newTicketFormValues = {} } = nextProps;
    const { tktTags: newTktTags = [] } = newTicketFormValues;

    if (!this.isArrayEqual(lastTktTags, newTktTags)) {
      this.setState({
        tagsSelected: lastTktTags,
      });
    }
  }

  isArrayEqual(x, y) {
    return _(x)
      .differenceWith(y, _.isEqual)
      .isEmpty();
  }
  componentWillMount() {
    if (!this.props.login) {
      this.props.history.replace(LOGIN_ROUTE);
    }
    this.props.actionGetCategories(null, (e) => {
      console.log("ERROR AL LISTAR CATEGORIAS", e);
    });
    this.props.actionGetTags(
      () => {
        this.setState({ tags: this.props.tagList });
      },
      (e) => {
        console.log("ERROR AL LISTAR TAGS", e);
      }
    );
    this.props.actionGetTicketTypes(
      () => {},
      () => {}
    );

    var ticket = this.props.history.location.state;
    if (this.props.isEditing) {
      ticket.tktInitDate =
        ticket.tktInitDate &&
        Util.timestampToMoment(ticket.tktInitDate).format("YYYY-MM-DDTHH:mm");
      ticket.tktEndDate =
        ticket.tktEndDate &&
        Util.timestampToMoment(ticket.tktEndDate).format("YYYY-MM-DDTHH:mm");
      ticket.tktOutdateDate =
        ticket.tktOutdateDate &&
        Util.timestampToMoment(ticket.tktOutdateDate).format(
          "YYYY-MM-DDTHH:mm"
        );
      this.props.initialize(ticket);
      const { tktComboSubTickets = [], tktCategory } = ticket;
      this.setState({
        isCombo: tktCategory === "Combo" ? true : false,
        selectedComboList: tktComboSubTickets,
        dynamicComboList: tktComboSubTickets,
      });
    } else {
      this.props.initialize({
        tktColor: "#000000",
        tktSellRrppEnable: false,
        tktVisible: true,
        tktSoldOut: false,
      });
    }
  }

  handleSubmitFail(error) {
    console.log("ERROR EN EL SUBMIT", error);
  }

  onChangeTktPriceProducer(evt) {
    this.props.change("tktLoyaltiPoints", Util.toNumber(evt.target.value));
  }

  onSelectIcon({ icon, family }) {
    this.props.change("tktIcon", icon);
    this.props.change("tktIconFamily", family);
  }

  onClean() {
    if (this.props.isEditing) {
      let ticket = this.props.history.location.state;
      this.props.initialize({
        id: ticket.id,
        tktColor: "#000000",
        tktSellRrppEnable: false,
        tktVisible: true,
        tktSoldOut: false,
      });
    } else {
      this.props.initialize({
        tktColor: "#000000",
        tktSellRrppEnable: false,
        tktVisible: true,
        tktSoldOut: false,
      });
    }
  }

  onSave(formValues) {
    const { tagsSelected = [], selectedComboList = [], isCombo } = this.state;
    formValues.tktTags = tagsSelected;
    const tktComboSubTickets = [];

    if (isCombo && selectedComboList.length == 0) {
      Util.showNoty(ERROR, "Debe seleccionar tipo de tickets para el combo");
      return;
    }
    selectedComboList.map((each) => tktComboSubTickets.push(each));
    formValues.tktComboSubTickets = tktComboSubTickets;
    this.props.actionSaveTicketType(
      formValues,
      () => {
        Util.showNoty(SUCCESS, "El ticket se guardó correctamente.");
        this.props.history.goBack();
      },
      (e) => {
        console.log("ERROR ON SAVE TICKET", e);
        if (!(e && e.status && e.status == 401))
          Util.showNoty(ERROR, "No se pudo guardar el ticket.");
      }
    );
  }

  onSelectTag(evt, tag) {
    let tags = tag.slice();
    this.setState({ tagsSelected: tags });
  }

  renderTags(type, tags) {
    let t = tags && tags.filter((t) => !t.add);
    return (
      t &&
      t.map((tag) => (
        <Chip
          label={tag.tagName}
          onDelete={this.onDeleteRenderTag.bind(this, type, tag)}
          avatar={
            <Avatar
              style={{ backgroundColor: tag.tagColor, color: "rgb(0,0,0,0.60" }}
            >
              {tag.tagName.substring(0, 1)}
            </Avatar>
          }
        />
      ))
    );
  }

  onDeleteRenderTag(type, tag) {
    let tags = null;
    let idx = -1;
    tags = this.state.tagsSelected.slice();
    idx = tags.findIndex((t) => t.id == tag.id);
    if (idx >= 0) {
      tags.splice(idx, 1);
    }
    this.setState({ tagsSelected: tags });
    console.log("ON DELETE RENDER TAG", type, tag, idx);
  }
  render() {
    const {
      theme,
      handleSubmit,
      event,
      ticketFormValues,
      categoryList,
    } = this.props;

    return (
      <Box style={theme.mainContainer}>
        <Box
          style={{
            ...theme.title.container,
            flexDirection: "row",
            display: "flex",
          }}
        >
          <Box style={theme.title.backIconContainer}>
            <Tooltip title="Atrás">
              <IconButton
                onClick={this.props.history.goBack}
                style={theme.title.backIcon}
              >
                <BackIcon
                  style={{ fontSize: "2.5rem" }}
                  stroke="white"
                  strokeWidth={3}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </IconButton>
            </Tooltip>
          </Box>
          <Box>
            <Typography variant="h1">{event && event.evtName}</Typography>
            <Typography variant="subtitle1">
              Crea tipo de tickets para el evento seleccionado
            </Typography>
          </Box>
        </Box>
        <Container>
          <Paper>
            <Box style={theme.paper.addEditTicketTypeTitle}>
              <Typography style={theme.paper.title} variant="h2">
                Crear tipo de ticket
              </Typography>
              <Typography style={theme.paper.title} variant="h2">
                Fecha del evento:{" "}
                {event &&
                  Util.formatDateToShow(
                    Util.timestampToMoment(event.evtDateTime)
                  )}
              </Typography>
            </Box>
            <form style={theme.paper.form}>
              <Grid container spacing={2}>
                {/* <Grid item xs={3}>
                  <Field
                    component={TextField}
                    name="tktName"
                    label="Nombre de tipo de ticket(sin espacios)"
                    fullWidth
                    validate={[required]}
                  />
                </Grid> */}
                <Grid item xs={3}>
                  <Field
                    component={TextField}
                    name="tktName"
                    label="Nombre a mostrar en la compra"
                    fullWidth
                    validate={[required]}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Field
                    component={TextField}
                    name="tktDisplayName"
                    label="Nombre a mostrar en el ticket vendido"
                    fullWidth
                    validate={[required]}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Field
                    component={TextField}
                    name="tktProducerName"
                    label="Nombre a mostrar en estadísticas"
                    fullWidth
                    validate={[required]}
                  />
                </Grid>
                <Grid item xs={3}>
                  <InputLabel shrink fullWidth>
                    Categoría de ticket
                  </InputLabel>
                  <Field
                    component={Select}
                    select
                    name="tktCategory"
                    onChange={(evt, b) => {
                      this.setState({
                        isCombo: b === "Combo" ? true : false,
                      });
                    }}
                    fullWidth
                    validate={[required]}
                  >
                    {categoryList.map((c) => {
                      return <MenuItem value={c.id}>{c.id}</MenuItem>;
                    })}
                  </Field>
                </Grid>
                <Grid item xs={2}>
                  <Field
                    component={TextField}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">$</InputAdornment>
                      ),
                    }}
                    format={Util.formatNumberWith0}
                    parse={Util.toNumber}
                    name="tktPrice"
                    label="Precio (en AR$)"
                    fullWidth
                    validate={[required, typeIntegerOrDecimalOr0]}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Field
                    component={TextField}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">$</InputAdornment>
                      ),
                    }}
                    format={Util.formatNumberWith0}
                    parse={Util.toNumber}
                    name="tktPriceProducer"
                    label="$ a rendir a productor"
                    fullWidth
                    validate={[required, typeIntegerOrDecimalOr0]}
                    onChange={this.onChangeTktPriceProducer}
                  />
                </Grid>
                <Grid item xs={2}>
                  <InputLabel shrink fullWidth>
                    Color de ticket
                  </InputLabel>
                  <Field
                    component={ColorField}
                    name="tktColor"
                    validate={[required]}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Field
                    component={TextField}
                    type="datetime-local"
                    InputLabelProps={{ shrink: true }}
                    name="tktInitDate"
                    label="Fecha disponible desde"
                    fullWidth
                    validate={[required]}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Field
                    component={TextField}
                    type="datetime-local"
                    InputLabelProps={{ shrink: true }}
                    name="tktEndDate"
                    label="Fecha disponible hasta"
                    fullWidth
                    validate={[required]}
                  />
                </Grid>
                <Grid item xs={2}>
                  <InputLabel shrink fullWidth>
                    ícono de tickets
                  </InputLabel>
                  <IconPicker
                    size={36}
                    onSelect={this.onSelectIcon}
                    icon={ticketFormValues && ticketFormValues.tktIcon}
                    iconset={ticketFormValues && ticketFormValues.tktIconFamily}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Field
                    component={TextField}
                    format={Util.formatNumber}
                    parse={Util.toNumber}
                    name="tktMaxQtBuy"
                    label="Máx. tickets por usuario"
                    fullWidth
                    validate={[required, typeInteger]}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Field
                    component={TextField}
                    format={Util.formatNumber}
                    parse={Util.toNumber}
                    name="tktQtOriginal"
                    label="Lote total de tickets"
                    fullWidth
                    validate={[required, typeInteger]}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Field
                    component={TextField}
                    format={Util.formatNumber}
                    parse={Util.toNumber}
                    name="tktQt"
                    label="Tickets disponibles"
                    fullWidth
                    validate={[required, typeInteger]}
                  />
                </Grid>
                <Grid item xs={2}>
                  <InputLabel shrink>¿Esta Sold Out?</InputLabel>
                  <Field
                    component={Select}
                    name="tktSoldOut"
                    fullWidth
                    validate={[required]}
                  >
                    <MenuItem value={true}>SI</MenuItem>
                    <MenuItem value={false}>NO</MenuItem>
                  </Field>
                </Grid>
                <Grid item xs={2}>
                  <InputLabel shrink>¿Tipo de ticket visible?</InputLabel>
                  <Field
                    component={Select}
                    name="tktVisible"
                    fullWidth
                    validate={[required]}
                  >
                    <MenuItem value={true}>SI</MenuItem>
                    <MenuItem value={false}>NO</MenuItem>
                  </Field>
                </Grid>
                <Grid item xs={2}>
                  <Field
                    component={TextField}
                    type="datetime-local"
                    InputLabelProps={{ shrink: true }}
                    name="tktOutdateDate"
                    label="Vencimiento del ticket"
                    fullWidth
                    validate={[required]}
                  />
                </Grid>
                <Grid item xs={2}>
                  <InputLabel shrink>¿Habilitada venta RRPP?</InputLabel>
                  <Field
                    component={Select}
                    name="tktSellRrppEnable"
                    fullWidth
                    validate={[required]}
                  >
                    <MenuItem value={true}>SI</MenuItem>
                    <MenuItem value={false}>NO</MenuItem>
                  </Field>
                </Grid>
                {Settings.hasLoyaly == "active" && (
                  <Grid item xs={2}>
                    <Field
                      component={TextField}
                      format={Util.formatNumberWith0}
                      parse={Util.toNumber}
                      name="tktLoyaltiPoints"
                      label="Puntos"
                      fullWidth
                      validate={[required, typeIntegerOrDecimalOr0]}
                    />
                  </Grid>
                )}
                <Box
                  style={{
                    display: "flex",
                    width: "40%",
                    marginLeft: 10,
                    paddingRight: 10,
                    marginTop: 20,
                  }}
                >
                  <Autocomplete
                    options={this.state.tags}
                    value={this.state.tagsSelected}
                    getOptionLabel={(option) => option.tagName}
                    filterOptions={(options, params) => {
                      return filterTag(options, params);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        label="Asocia el tipo de ticket a un tag"
                      />
                    )}
                    renderTags={this.renderTags.bind(this, "filter")}
                    onChange={this.onSelectTag}
                    loadingText="Cargando tags ..."
                    noOptionsText="Sin tags"
                    selectOnFocus
                    multiple
                    freeSolo
                    filterSelectedOptions
                  />
                </Box>
              </Grid>
            </form>
          </Paper>
          <Toolbar style={theme.footer.toolbar}>
            <Tooltip title="Limpiar">
              <Button
                variant="contained"
                color="secondary"
                style={theme.footer.button}
                onClick={this.onClean}
              >
                Limpiar
              </Button>
            </Tooltip>
            <Tooltip title="Cancelar">
              <Button
                variant="contained"
                color="secondary"
                style={theme.footer.button}
                onClick={this.props.history.goBack}
              >
                Cancelar
              </Button>
            </Tooltip>
            <Tooltip title="Guardar">
              <Button
                variant="contained"
                color="primary"
                style={theme.footer.button}
                onClick={handleSubmit(this.onSave)}
              >
                Guardar
              </Button>
            </Tooltip>
          </Toolbar>
          {this.state.isCombo ? (
            <AddDynamicCombo
              theme={theme}
              selectedComboList={this.state.selectedComboList}
              onAddNewIndex={() => {
                this.setState({
                  dynamicComboList: [...this.state.dynamicComboList, {}],
                });
              }}
              ticketTypeList={
                this.props.ticketTypeList
                  ? this.props.ticketTypeList.filter(
                      (e) => e.tktCategory != "Combo"
                    )
                  : []
              }
              onDeleteLastIndex={(index) => {
                let comboListClone = [...this.state.dynamicComboList];
                comboListClone.splice(index, 1);
                let selectedComboListClone = [...this.state.selectedComboList];
                selectedComboListClone.length > 0 &&
                  selectedComboListClone.splice(index, 1);
                this.setState({
                  dynamicComboList: comboListClone,
                  selectedComboList: selectedComboListClone,
                });
              }}
              list={this.state.dynamicComboList}
              onSelect={(evt, index) => {
                let selectedComboList = [...this.state.selectedComboList];
                selectedComboList[index] = evt.target.value;
                this.setState({
                  selectedComboList,
                });
              }}
            />
          ) : null}
        </Container>
      </Box>
    );
  }
}
function mapStateToProps(store) {
  // console.log("STORE", store)
  return {
    login: store.auth.login,
    event: store.evt.event,
    tagList: store.tag.tagList,
    ticketTypeList: store.evt.ticketTypeList,
    ticketFormValues:
      store.form &&
      store.form.addEditTicketType &&
      store.form.addEditTicketType.values,
    categoryList: store.evt.categoryList,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionGetCategories,
      actionGetTicketTypes,
      actionSaveTicketType,
      actionGetTags,
    },
    dispatch
  );
}

export default reduxForm({
  form: "addEditTicketType",
  onSubmitFail: (errors) => _handleSubmitFail(errors),
})(
  withRouter(
    withTheme(connect(mapStateToProps, mapDispatchToProps)(AddEditTicketType))
  )
);

const AddDynamicCombo = ({
  onSelect,
  onAddNewIndex,
  onDeleteLastIndex,
  list,
  theme,
  selectedComboList = [],
  ticketTypeList = [],
}) => {
  return (
    <Container>
      <Paper>
        <Box style={theme.paper.addEditTicketTypeTitle}>
          <Typography style={theme.paper.title} variant="h2">
            Seleccione Tipo de Ticket para el Combo
          </Typography>
        </Box>
        {list &&
          list.length > 0 &&
          list.map((val, index) => {
            const defaultVal =
              selectedComboList.length > 0 && selectedComboList[index]
                ? selectedComboList[index]
                : {};
            return (
              <Box style={{ margin: 30 }}>
                <InputLabel shrink fullWidth>
                  Tipo de ticket
                </InputLabel>
                <SelectMUI
                  style={{ margin: "30px" }}
                  onChange={(e) => onSelect(e, index)}
                  displayEmpty
                  select
                  fullWidth
                  value={
                    ticketTypeList &&
                    ticketTypeList.find((e) => e.id == defaultVal.id)
                  }
                >
                  {ticketTypeList &&
                    ticketTypeList.map((c, index) => {
                      return (
                        <MenuItem value={c} key={index}>
                          {c.tktDisplayName}
                        </MenuItem>
                      );
                    })}
                </SelectMUI>
                <Box>
                  <Tooltip title="Eliminar Tipo de Ticket">
                    <Button
                      variant="contained"
                      color="secondary"
                      style={theme.footer.buttonMarginBottom}
                      onClick={() => onDeleteLastIndex(index)}
                    >
                      Eliminar
                    </Button>
                  </Tooltip>
                </Box>
              </Box>
            );
          })}
      </Paper>
      <Toolbar style={theme.footer.toolbar}>
        <Tooltip title="Agregar Tipo de ticket">
          <Button
            variant="contained"
            color="secondary"
            style={theme.footer.button}
            onClick={onAddNewIndex}
          >
            Agregar
          </Button>
        </Tooltip>
      </Toolbar>
    </Container>
  );
};



// WEBPACK FOOTER //
// ./src/screens/events/AddEditTicketType.js